import React from 'react'
import ReactDOM from 'react-dom'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import ReactPixel from 'react-facebook-pixel'
import App from './App'
import { unregister } from './registerServiceWorker'
import './vendor'
import './vendorStyles'
import './index.css'

ReactPixel.init(process.env.REACT_APP_FACEBOOK_PIXEL_ID)

ReactDOM.render(<App />, document.getElementById('root'))
unregister()



// WEBPACK FOOTER //
// ./src/index.js